module.exports = __webpack_public_path__ + "media/sonic.caabb6a6.wav";